import React, { useId } from 'react'

import { Icon } from '../Icon'
import { SvgProps } from '../types'

export const Gift: React.FC<SvgProps> = (props) => {
  const id = useId()
  return (
    <Icon
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.25 3C15.9069 3 17.25 4.34315 17.25 6C17.25 6.54713 17.1006 7.05836 16.8447 7.5H19.5L20.25 8.25V12L19.5 12.75H18.75V19.2656L17.6133 20.25H6.38672L5.25 19.2656V12.75H4.5L3.75 12V8.25L4.5 7.5H7.15527C6.89941 7.05836 6.75 6.54713 6.75 6C6.75 4.34315 8.09315 3 9.75 3C10.6471 3 11.4502 3.39544 12 4.01953C12.5498 3.39544 13.3529 3 14.25 3ZM6.75 18.5801L6.94629 18.75H11.25V12.75H6.75V18.5801ZM12.75 18.75H17.0537L17.25 18.5801V12.75H12.75V18.75ZM5.25 11.25H11.25V9H5.25V11.25ZM12.75 11.25H18.75V9H12.75V11.25ZM9.75 4.5C8.92157 4.5 8.25 5.17157 8.25 6C8.25 6.82843 8.92157 7.5 9.75 7.5H11.25V6C11.25 5.17157 10.5784 4.5 9.75 4.5ZM14.25 4.5C13.4216 4.5 12.75 5.17157 12.75 6V7.5H14.25C15.0784 7.5 15.75 6.82843 15.75 6C15.75 5.17157 15.0784 4.5 14.25 4.5Z"
        fill="currentColor"
      />
    </Icon>
  )
}
